const Compression = {
    GZipJS: 'gzip-js',
    Base64: 'base64'
};
export { Compression };
